import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.2426 5.5533C17.6569 5.5533 17.9926 5.88909 17.9926 6.3033L17.9926 14.7886C17.9926 15.2028 17.6569 15.5386 17.2426 15.5386C16.8284 15.5386 16.4926 15.2028 16.4926 14.7886L16.4926 8.11396L6.45926 18.1473C6.16637 18.4402 5.6915 18.4402 5.3986 18.1473C5.10571 17.8544 5.10571 17.3796 5.3986 17.0867L15.432 7.0533L8.75736 7.0533C8.34315 7.0533 8.00736 6.71751 8.00736 6.3033C8.00736 5.88909 8.34315 5.5533 8.75736 5.5533L17.2426 5.5533Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgArrowUpRight);
export default ForwardRef;
